import { useAppSelector } from '@/redux/hooks';
import { getCatalogLotsListed } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogCurrentItemIndex } from '@/redux/modules/console';

type Props = {
    catalogId: number;
};

const ProgressBarComponent = ({ catalogId }: Props) => {
    const lotsListed = useAppSelector((state) => getCatalogLotsListed(state, catalogId));
    const itemIndex = useAppSelector((state) => getLiveCatalogCurrentItemIndex(state, catalogId));

    const percentage = Math.round(((itemIndex + 1) / lotsListed) * 100);

    return (
        <div className="h-[5px] flex-[1_1_auto] bg-surface-200">
            <span
                className="block h-full bg-critical-300 transition-all duration-[250ms]"
                style={{ width: `${percentage}%` }}
            />
        </div>
    );
};

export const ProgressBar = ProgressBarComponent;
